import type { ReactNode } from 'react';

/**
 * As três telas que todo painel tem e que nenhum desenho estático mostra: carregando,
 * vazio e erro.
 *
 * <p>Estão juntas de propósito. Espalhadas, cada tela inventa a sua — e a diferença entre
 * "ainda não carregou", "não há nada" e "deu erro" some, justo quando ela é a única coisa
 * que a pessoa na frente da tela precisa saber.
 */

export function Carregando({ o }: { o?: string }) {
  return (
    <div className="estado">
      <div>
        <div className="t">Carregando{o ? ` ${o}` : ''}…</div>
      </div>
    </div>
  );
}

/**
 * @param acao o que fazer a respeito. Um vazio sem saída é um beco: a tela diz que não há
 *             nada e a pessoa não descobre como fazer haver
 */
export function Vazio({ titulo, detalhe, acao }: { titulo: string; detalhe?: string; acao?: ReactNode }) {
  return (
    <div className="estado">
      <div>
        <div className="t">{titulo}</div>
        {detalhe && <div className="s">{detalhe}</div>}
        {acao && <div style={{ marginTop: 16 }}>{acao}</div>}
      </div>
    </div>
  );
}

/**
 * O erro com a mensagem do servidor, não com "algo deu errado".
 *
 * <p>O catálogo de erros existe para que o cliente saiba o que aconteceu — engoli-lo aqui
 * desperdiçaria a única parte do sistema que já sabe explicar a falha.
 */
export function Erro({ erro }: { erro: unknown }) {
  const mensagem = erro instanceof Error ? erro.message : 'Não foi possível carregar.';
  return (
    <div className="estado erro">
      <div>
        <div className="t">Não deu certo</div>
        <div className="s">{mensagem}</div>
      </div>
    </div>
  );
}
